import { Navigate } from 'react-router-dom'

import { PreloadableRouteObject, TFileToRouteMap } from '~/app/models'
import { getRoutesFromMap } from '~/app/utils/lazy'
import { EClientPath } from '~/models/api'

type TFileToRouteAdminPartnerMap = TFileToRouteMap & {
  [x: string]: { isComponentForPartnerAdminOnly?: boolean }
}

const partnerAdminPortalRoutesFileToRouteMap: TFileToRouteAdminPartnerMap = {
  branding: {
    isComponentForPartnerAdminOnly: true,
    path: EClientPath.partnerBranding,
    getImportPromise: () =>
      import('~/features/partnerAdmin/components/branding'),
  },
  partnerPayments: {
    path: EClientPath.partnerPayments,
    getImportPromise: () =>
      import('~/features/partnerAdmin/components/partnerPayments'),
  },
  portalConfigGeneralSettings: {
    isComponentForPartnerAdminOnly: true,
    path: EClientPath.partnerGeneralSettings,
    getImportPromise: () =>
      import('~/features/partnerAdmin/components/portalConfigGeneralSettings'),
  },
  partnerReports: {
    path: EClientPath.partnerAdminReports,
    getImportPromise: () =>
      import('~/features/partnerAdmin/components/reports'),
  },
  partnerAdminUserManagement: {
    path: EClientPath.partnerAdminUserManagement,
    getImportPromise: () =>
      import('~/features/partnerAdmin/components/userManagement/searchUsers'),
  },
  partnerAdminUserManagementById: {
    path: EClientPath.partnerAdminUserManagementById,
    getImportPromise: () =>
      import('~/features/partnerAdmin/components/userManagement/editUser'),
  },
}

export const partnerAdminOnlyPortalRoutes: PreloadableRouteObject[] =
  getRoutesFromMap(
    Object.entries(partnerAdminPortalRoutesFileToRouteMap).reduce(
      (
        accumulation: TFileToRouteAdminPartnerMap,
        [currentRouteKey, currentRouteValue],
      ) => {
        if (currentRouteValue.isComponentForPartnerAdminOnly) {
          return {
            ...accumulation,
            [currentRouteKey]: currentRouteValue,
          }
        }

        return accumulation
      },
      {} as TFileToRouteAdminPartnerMap,
    ),
  ).concat({
    index: true,
    element: <Navigate to={EClientPath.partnerGeneralSettings} replace />,
  } as PreloadableRouteObject)

export const partnerEditorPortalRoutes: PreloadableRouteObject[] =
  getRoutesFromMap(
    Object.entries(partnerAdminPortalRoutesFileToRouteMap).reduce(
      (
        accumulation: TFileToRouteAdminPartnerMap,
        [currentRouteKey, currentRouteValue],
      ) => {
        if (!currentRouteValue.isComponentForPartnerAdminOnly) {
          return {
            ...accumulation,
            [currentRouteKey]: currentRouteValue,
          }
        }

        return accumulation
      },
      {} as TFileToRouteAdminPartnerMap,
    ),
  ).concat({
    index: true,
    element: <Navigate to={EClientPath.partnerAdminUserManagement} replace />,
  } as PreloadableRouteObject)
